import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Loads all owned channels for use in filter dropdowns / forms
export function useChannels() {
  const [channels, setChannels] = useState([]);
  useEffect(() => {
    api.get("/channels", { limit: 100 }).then((res) => setChannels(res.data || [])).catch(() => {});
  }, []);
  return channels;
}
